export const ActionType = {
  DELETE: "DELETE",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
}

export const ActionTypeOptions = [
  { value: ActionType.CREATE, name: "Create" },
  { value: ActionType.UPDATE, name: "Update" },
  { value: ActionType.DELETE, name: "Delete" },
]
